import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../shared/store';

export interface HubLayout {
  pageTitle: string;
}

const initialState: HubLayout = {
  pageTitle: null,
};

export const hubLayoutSlice = createSlice({
  name: 'hubLayoutSlice',
  initialState,
  reducers: {
    setHubPageTitle: (state, { payload }) => ({
      ...state,
      pageTitle: payload,
    }),
  },
  extraReducers: () => {},
});

export const { setHubPageTitle } = hubLayoutSlice.actions;
export const hubLayoutSelector = (state: RootState) => state.hubLayout;
